import { InjectionToken } from '@angular/core';

export const MISSING_PRODUCT_IMAGE_URL = new InjectionToken<string>('assets/images/product-default-img.png');
